import I18n from 'I18n';
import { SET_HUBDB_ROWS_AND_SCHEMA } from 'structured-content-lib/redux/actions/ActionTypes';

/**
 * Hacky middleware that sets the label and inline_help_text of inline editable built-in HubDB columns
 * Currently, HubDB can't store translated labels and descriptions on built in columns
 * In the interim while we work on a better solution, this middleware will listen to
 * the `SET_HUBDB_ROWS_AND_SCHEMA` action that's fired by structured-content-lib when the requests for the table
 * as a module schema come back. Before it reaches its reducer to be stored, we'll mutate the field's we care about to
 * include the translated label and inline_help_text for the column
 */
export default function hubDbColumnLabelAndDescriptionMiddleware() {
  return __store => next => action => {
    if (action.type === SET_HUBDB_ROWS_AND_SCHEMA) {
      const {
        payload
      } = action;
      const {
        tableSchema
      } = payload;
      if (!tableSchema) {
        return next(action);
      }
      const {
        fields
      } = tableSchema;
      fields.forEach(field => {
        if (field.name === 'hs_name') {
          field.inline_help_text = I18n.text('knowledgeArticleDescriptions.title');
          field.label = undefined;
          field.required = true;
          field.required_for_saving = true;
        } else if (field.name === 'hs_summary') {
          field.inline_help_text = I18n.text('knowledgeArticleDescriptions.summary');
          field.label = I18n.text('knowledgeArticleLabels.summary');
        }
      });
    }
    return next(action);
  };
}